/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsPaymentListItem
 */
export interface IdentityMelcoModelsPaymentListItem {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    product_level_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    qty?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    discount_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    tax_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    total_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    payout_price?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    payout_discount_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    payout_tax_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    payout_total_amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    transaction_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    affiliate_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    affiliate_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    acc_resource_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    country_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    org_unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsPaymentListItem
     */
    invoice_url?: string | null;
}

export function IdentityMelcoModelsPaymentListItemFromJSON(json: any): IdentityMelcoModelsPaymentListItem {
    return IdentityMelcoModelsPaymentListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsPaymentListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsPaymentListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_level_code': !exists(json, 'product_level_code') ? undefined : json['product_level_code'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'discount_amount': !exists(json, 'discount_amount') ? undefined : json['discount_amount'],
        'tax_amount': !exists(json, 'tax_amount') ? undefined : json['tax_amount'],
        'total_amount': !exists(json, 'total_amount') ? undefined : json['total_amount'],
        'payout_price': !exists(json, 'payout_price') ? undefined : json['payout_price'],
        'payout_discount_amount': !exists(json, 'payout_discount_amount') ? undefined : json['payout_discount_amount'],
        'payout_tax_amount': !exists(json, 'payout_tax_amount') ? undefined : json['payout_tax_amount'],
        'payout_total_amount': !exists(json, 'payout_total_amount') ? undefined : json['payout_total_amount'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'transaction_id': !exists(json, 'transaction_id') ? undefined : json['transaction_id'],
        'affiliate_code': !exists(json, 'affiliate_code') ? undefined : json['affiliate_code'],
        'affiliate_name': !exists(json, 'affiliate_name') ? undefined : json['affiliate_name'],
        'acc_resource_id': !exists(json, 'acc_resource_id') ? undefined : json['acc_resource_id'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
        'org_unit': !exists(json, 'org_unit') ? undefined : json['org_unit'],
        'invoice_url': !exists(json, 'invoice_url') ? undefined : json['invoice_url'],
    };
}

export function IdentityMelcoModelsPaymentListItemToJSON(value?: IdentityMelcoModelsPaymentListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'melco_customer_id': value.melco_customer_id,
        'user_name': value.user_name,
        'product_code': value.product_code,
        'product_level_code': value.product_level_code,
        'qty': value.qty,
        'price': value.price,
        'discount_amount': value.discount_amount,
        'tax_amount': value.tax_amount,
        'total_amount': value.total_amount,
        'payout_price': value.payout_price,
        'payout_discount_amount': value.payout_discount_amount,
        'payout_tax_amount': value.payout_tax_amount,
        'payout_total_amount': value.payout_total_amount,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'transaction_id': value.transaction_id,
        'affiliate_code': value.affiliate_code,
        'affiliate_name': value.affiliate_name,
        'acc_resource_id': value.acc_resource_id,
        'country_code': value.country_code,
        'org_unit': value.org_unit,
        'invoice_url': value.invoice_url,
    };
}


